(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cd-reopening-poster"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cd-fit-headline')) {
    customElements.define('cd-fit-headline', class extends HTMLElement {
      connectedCallback() {
        this.scheduleFit = () => {
          cancelAnimationFrame(this.fitFrame);
          this.fitFrame = requestAnimationFrame(() => this.fit());
        };
        this.resizeObserver = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.lastWidth) {
            this.lastWidth = width;
            this.scheduleFit();
          }
        });
        this.resizeObserver.observe(this);
        window.addEventListener('resize', this.scheduleFit, { passive: true });
        document.fonts.addEventListener('loadingdone', this.scheduleFit);
        document.fonts.ready.then(() => { if (this.isConnected) this.scheduleFit(); });
        this.scheduleFit();
      }
      fit() {
        if (!this.isConnected || !this.clientWidth) return;
        this.style.setProperty('--cd-headline-fit', '1');
        const longestWord = Math.max(0, ...Array.from(this.children, word => word.getBoundingClientRect().width));
        const available = this.getBoundingClientRect().width;
        const scale = longestWord > available ? (available - 2) / longestWord : 1;
        this.style.setProperty('--cd-headline-fit', String(scale));
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.fitFrame);
        this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.scheduleFit);
        document.fonts.removeEventListener('loadingdone', this.scheduleFit);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
